import React from 'react';
import classnames from 'classnames';
import { Helmet } from "react-helmet";
import API from '../../functions/api';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import { getStateFromPostcode } from '../../functions/location';
import Layout from '../../components/Layout';
import queryString from 'query-string';
import ModelModule from '../../components/ModelModule';
import Select from '../../audi-ui-components/Select';
import TextField from '../../audi-ui-components/TextField';
import Spinner from '../../audi-ui-components/Spinner';
import Modal from '../../audi-ui-components/Modal';
import Offer from './components/Offer';
import Button from '../../audi-ui-components/Button';
import IconFuelStation from '../../audi-ui-components/icons/FuelStation';
import IconChargingStation from '../../audi-ui-components/icons/ChargingStation';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _filter from 'lodash/filter';
import './PriceCalculator.scss';
import {
    UI_AUDI,
    PATH_PRICECALCULATOR,
    PATH_REQUEST_TESTDRIVE,
    DEFAULT_THEME,
} from '../../constants';

const TODAY = new Date();

class PriceCalculator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modelId: "",
            variantId: "",
            engineId: "",
            selectedModel: null,
            selectedVariant: null,
            locState: "",
            locPostcode: "",
            my: "",
            postcodeError: false,
            engineOpts: [],
            isFetchingEngines: false,
            prices: {},
            pricesError: false,
            isFetchingPrices: false,
            offers: []
        }
    }

    componentDidMount() {
        this.isIframed = typeof window !== "undefined" && window.self !== window.top;
        gtmPageview(this.props.location.pathname);
        // fetch offers
        API.get(
          `${process.env.RAZZLE_CMS_HOST}/1/cms/formOffers`
        ).then((response) => {
            if (response.data && response.data.length) {
              let offers = response.data;
              for (let o=0; o<offers.length; o++) {
                let offer = offers[o];
                offer.engineIds = [];
                offer.disclaimer = offer.disclaimer.replace("<small>", "<span>").replace("</small>", "</span>");
                for (let m=0; m<offer.models.length; m++) {
                  offer.engineIds.push(offer.models[m].id);
                }
                offers[o] = offer;
              }
              this.setState({offers: offers});
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    componentDidUpdate(prevProps, prevState) {
      // console.log("componentDidUpdate", prevState, this.state);
      if (
        (this.state.variantId && this.state.engineId && this.state.locState) &&
        (
          prevState.variantId !== this.state.variantId ||
          prevState.engineId !== this.state.engineId ||
          prevState.locState !== this.state.locState
        )
      ) {
        // console.log("gtm test");
        let formName = this.props.match.path.indexOf(PATH_PRICECALCULATOR) !== -1 ? 'priceCalculator' : 'startingPriceCalculator';
        if (this.state.selectedModel && this.state.selectedVariant) {
          gtmPush("form", "formSubmitSuccess", formName, {model: this.state.selectedModel.label, state: this.state.locState, variant: this.state.selectedVariant.label});
        }
      }
    }

    handleChangeVariant = (field, v, opt) => {
        // console.log("handleChangeVariant", field, v);
        // model
        if (field === 'modelId') {
          if (!v || v === null) {
            this.setState({modelId: v, selectedModel: null});
          } else {
            this.setState({modelId: v, selectedModel: opt});
          }
        }
        // variant
        if (field === 'variantId') {
          if (!v || v === null) {
            return this.setState({variantId: v, selectedVariant: null, engineId: "", engineOpts: [], pricesError: false});
          }
          this.setState({isFetchingEngines: true, variantId: v, selectedVariant: opt});
          API.post(`${process.env.RAZZLE_GQLAPI}`, {
            query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: EngineDtoSortInput!, $filter: EngineDtoFilterInput) {
              engineList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
                items {
                  value: engineId
                  label: name
                  modelCode
                  year
                }
                totalCount
              }
            }`,
            variables: {
              skip: 0,
              take: 50,
              sort: {displayOrder: "ASC"},
              filter: {status: {eq: true}, variantId: {eq: v}}
            }
          }).then((response) => {
            var opts = response.data?.data?.engineList?.items ? response.data.data.engineList.items : [];
            this.setState({isFetchingEngines: false, engineOpts: opts});
            if (opts.length > 0) {
              this.handleChangeEngine(opts[0].value);
            }
          }).catch((error) => {
            console.error(error);
            this.setState({isFetchingEngines: false});
          });
        }
    }

    handleChangeEngine = (v) => {
        let eng = _find(this.state.engineOpts, function (o) { return o.value.toString() === v.toString()});
        let my = eng?.year ? `MY${eng.year.toString().substring(2)}` : "";
        // console.log("handleChangeEngine", v, eng, my);
        this.setState({engineId: v, my: my, pricesError: false});
        this.getPrices(undefined, v, undefined);
    }

    handleChangeState = (v) => {
        this.setState({locState: v});
        this.getPrices(undefined, undefined, v);
    }

    getPrices = (_variant, _engine, _state) => {
        var variant = _variant || this.state.variantId;
        var engine = _engine || this.state.engineId;
        var locState = _state || this.state.locState;
        const {prices} = this.state;
        if (prices[locState] && prices[locState][engine]) {
            return;
        } else if (variant && engine && locState) {
            this.setState({isFetchingPrices: true});
            API.get(
                `/1/legacy/GetPrice?variantId=${variant}&state=${locState}&engineId=${engine}`
            ).then((response) => {
              if (response.data?.success) {
                var newPrices = {...prices};
                newPrices[locState] = Object.assign({}, prices[locState], {[engine]: response.data?.data});
                this.setState({isFetchingPrices: false, prices: newPrices});
              } else {
                this.setState({isFetchingPrices: false, pricesError: true});
              }
            }).catch((error) => {
                console.error(error);
                this.setState({isFetchingPrices: false, pricesError: true});
            });
        } else {
            return;
        }
    }

    handleTestDriveClick = () => {
        const {selectedVariant, selectedModel} = this.state;
        gtmPush("priceCalculator", "requestATestDriveClicked", "priceCalculator", {
          model: selectedModel?.label || "",
          variant: selectedVariant?.label,
          href: window.location.href,
          title: 'Test Drive'
        });
    }
    
    handleEnterPostcode = () => {
      let s = getStateFromPostcode(this.state.locPostcode);
      if (s && s !== null) {
        this.setState({locState: s});
        this.getPrices(undefined, undefined, s);
      } else {
        this.setState({postcodeError: true});
      }
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {engineId, selectedVariant, locState, locPostcode} = this.state;
        var selectedEngine = null;
        var selectedEngineType = "petrol";
        if (engineId) {
          selectedEngine = _find(this.state.engineOpts, function (o) { return o.value.toString() === engineId.toString(); });
          selectedEngineType = selectedEngine && selectedEngine.label.indexOf("Electric") > -1 ? "electric" : "petrol";
        }
        var prices = null;
        if (this.state.prices[this.state.locState] && this.state.prices[this.state.locState][engineId]) {
            prices = this.state.prices[this.state.locState][engineId];
        }
        const loading = this.state.isFetchingEngines || this.state.isFetchingPrices;
        var filteredOffers = [];
        if (engineId) {
            filteredOffers = _filter(this.state.offers, function (o) { return o.engineIds.indexOf(engineId) > -1; });
        }
        var showDetail = !this.state.isFetchingEngines && prices && selectedVariant;
        return (
            <Layout ui={this.isIframed ? null : query.ui ? query.ui : UI_AUDI} theme={query.theme}>
                <Helmet>
                    <title>Price Calculator | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page price-calculator pb-0">
                  
                  {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
                  
                  <div className="row">
                    <div className="col col-medium-6 pe-medium-5">
                      <h1 className="aui-headline-3 mb-2 mt-5">Starting Price Calculator</h1>
                      <div className="mb-5">
                        <ModelModule
                            labelVariant="Body type"
                            colClass="col-12 col-small-6"
                            values={{modelId: this.state.modelId, variantId: this.state.variantId}}
                            setFieldValue={this.handleChangeVariant}
                            form="startingPrice"
                            includeOptionObjOnChange
                            additionalVariantFields="visibilityRaTD vtpCarline startingPriceTestDriveCTA startingPriceStockCTA"
                            theme={theme}
                        />
                        <div className="form-field">
                          <Select name="engine"
                              label="Engine"
                              value={this.state.engineId}
                              options={this.state.engineOpts}
                              onChange={this.handleChangeEngine}
                              theme={theme === "dark" ? "light" : null}
                          />
                        </div>
                      </div>
                      
                      <div className={classnames("price-detail mb-5 py-5", {"active": showDetail})}>
                        {selectedVariant && <h4 className="aui-headline-4 mb-3 d-medium-none"><b>{selectedVariant.label}</b></h4>}
                        <hr className="my-3 d-medium-none" />
                        {selectedEngine && <div className="d-medium-none selected-engine">
                          {/*selectedEngine.power && <span><IconPower small /> {selectedEngine.power}</span>*/}
                          <span>
                            {selectedEngineType === "electric" && <IconChargingStation small />}
                            {selectedEngineType === "petrol" && <IconFuelStation small />}
                            {` ${selectedEngine.label}`}
                          </span>
                        </div>}
                        {prices && selectedVariant && <img src={prices.ImagePath} alt={selectedVariant.label} className="d-medium-none" />}
                        {this.state.pricesError && <p className="aui-color-text-red"><b>Could not get pricing.</b></p>}
                        <table className="price-table">
                            <tbody>
                                <tr>
                                    <td>Manufacturer{`'`}s List Price (Inc. GST)*</td>
                                    <td>{prices && prices.MLP}{!prices && "$--"}</td>
                                </tr>
                                <tr>
                                    <td>Recommended Dealer Delivery Fee (Inc. GST)#</td>
                                    <td>{prices && prices.DealerDeliveryFee}{!prices && "$--"}</td>
                                </tr>
                                <tr>
                                    <td>Federal Govt Luxury Car Tax (LCT)</td>
                                    <td>{prices && prices.LCT}{!prices && "$--"}</td>
                                </tr>
                                <tr>
                                    <td>{`${this.state.locState} State Govt Total Registration~`}</td>
                                    <td>{prices && prices.TotalRegistration}{!prices && "$--"}</td>
                                </tr>
                                <tr>
                                    <td>{`${this.state.locState} State Govt Stamp Duty`}</td>
                                    <td>{prices && prices.StampDuty}{!prices && "$--"}</td>
                                </tr>
                                <tr>
                                    <td><b>Vehicle Drive Away Price^</b></td>
                                    <td><b>{prices && prices.VehicleDriveAwayPrice}{!prices && "$--"}</b></td>
                                </tr>
                            </tbody>
                        </table>
                        
                        {showDetail && <div className="row mb-4 d-medium-none">
                          {selectedVariant.startingPriceStockCTA && <div className="col-12 col-xsmall-6 mb-2">
                            <Button
                              variant="secondary"
                              theme={theme === "dark" ? "light" : null}
                              isStretched
                              href={selectedVariant.vtpCarline ? `https://www.audi.com.au/au/web/en/audi-new-car-search/results.html#filter=carline.${selectedVariant.vtpCarline}` : "https://www.audi.com.au/au/web/en/audi-new-car-search.html"}
                              target="_blank"
                              rel="noreferrer">Check stock availability</Button>
                          </div>}
                          {selectedVariant?.visibilityRaTD && selectedVariant.startingPriceTestDriveCTA && <div className="col-12 col-xsmall-6 mb-2">
                            <Button
                              label="Request a test drive"
                              variant="primary"
                              theme={theme === "dark" ? "light" : null}
                              isStretched
                              className="me-4"
                              href={`${PATH_REQUEST_TESTDRIVE}?v=${this.state.variantId}`}
                              target="_blank"
                              onClick={this.handleTestDriveClick}
                            />
                          </div>}
                        </div>}

                        {showDetail && <p className="aui-small mb-4">
                            Prices effective from 1st July 2026<br />
                            Pricing does not take into account any current promotion.<br />
                            Contact your preferred Audi Dealer for any applicable promotional details.
                        </p>}

                        {showDetail && filteredOffers && filteredOffers.length > 0 && <div className="offers row mt-2 mb-5">
                            {filteredOffers.map(offer => (
                                <div key={`offer${offer.id}`} className={classnames("col-12", {"col-small-6 col-medium-12 col-large-6": filteredOffers.length > 1})}>
                                    <Offer offer={offer} />
                                </div>
                            ))}
                        </div>}

                        {showDetail && <p className="aui-small">
                            *Manufacturers List Price - excluding dealer delivery charges, statutory charges and optional extras.<br />
                            #Recommended Dealer Delivery Fee – Dealer delivery fee recommended by Audi Australia. Dealers may charge a different dealer delivery fee, which may be higher or lower.<br />
                            ~Registration fees are in accordance with the applicable state/territory legislation, fitted with a premium licence plate (where applicable) and based on private ownership.<br />
                            
                            ^Manufacturer's recommended driveaway price (MRDP) displayed for new {this.state.my} Audi Vehicles (with no optional extras). MRDP is an estimated price which includes the recommended retail price, 12 months private registration, 12 months compulsory third party insurance (CTP), an estimated dealer delivery charge, stamp duty and other applicable statutory charges that may apply such as Luxury Car Tax (LCT) for private use vehicles above a certain threshold. The MRDP displayed is based on information available at the time the price was calculated and published and does not constitute a binding quote or an offer of sale. The actual driveaway price will be agreed with the selling Audi Dealer. Actual prices and stock availability will vary between locations and dealers, and on-road costs will vary according to individual circumstances. Please contact your local Audi Dealer to confirm your individual price and vehicle lead-time. While stocks last.<br />
                            
                            Statutory charges current as at {TODAY.getDate()}-{TODAY.getMonth() + 1}-{TODAY.getFullYear()}.
                        </p>}
                      </div>
                    </div>
                  
                    <div className="d-none d-medium-block col-medium-6">
                      <div className="variant-detail" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/car-interior.jpg")`}}>
                        {prices && selectedVariant && <div className="variant-detail__inner px-4 py-5">
                          {selectedVariant && <h4 className="aui-headline-3"><b>{selectedVariant.label}</b></h4>}
                          <hr className="my-3" />
                          {selectedEngine && <div className="selected-engine">
                            {/*selectedEngine.power && <span><IconPower small /> {selectedEngine.power}</span>*/}
                            <span>
                              {selectedEngineType === "electric" && <IconChargingStation small />}
                              {selectedEngineType === "petrol" && <IconFuelStation small />}
                              {` ${selectedEngine.label}`}
                            </span>
                          </div>}
                          {prices && selectedVariant && <img src={prices.ImagePath} alt={selectedVariant.label} className="d-block my-5" />}
                          <div className="row mb-4">
                            {selectedVariant.startingPriceStockCTA && <div className="col-12 col-xlarge-6 mb-2">
                              <Button
                                variant="secondary"
                                theme={theme === "dark" ? "light" : null}
                                isStretched
                                href={selectedVariant.vtpCarline ? `https://www.audi.com.au/au/web/en/audi-new-car-search/results.html#filter=carline.${selectedVariant.vtpCarline}` : "https://www.audi.com.au/au/web/en/audi-new-car-search.html"}
                                target="_blank"
                                rel="noreferrer">Check stock availability</Button>
                            </div>}
                            {selectedVariant?.visibilityRaTD && selectedVariant.startingPriceTestDriveCTA && <div className="col-12 col-xlarge-6 mb-2">
                              <Button
                                label="Request a test drive"
                                variant="primary"
                                theme={theme === "dark" ? "light" : null}
                                isStretched
                                className="me-4"
                                href={`${PATH_REQUEST_TESTDRIVE}?v=${this.state.variantId}`}
                                target="_blank"
                                onClick={this.handleTestDriveClick}
                              />
                            </div>}
                          </div>
                        </div>}
                      </div>
                    </div>
                  </div>

                  <Modal isActive={!locState} variant="layer" className="postcodemodal">
                    <p className="aui-headline-4 mb-3">Enter your postcode</p>
                    <p className="mb-3">Statutory charges differ depending on your location. In order to provide the correct driveaway price, please enter your postcode.</p>
                    <div className="mb-3">
                      <TextField
                        value={locPostcode}
                        label="Postcode*"
                        onChange={(v)=>{ this.setState({locPostcode: v, postcodeError: false}); }}
                        onEnter={this.handleEnterPostcode}
                        isInvalid={this.state.postcodeError}
                        invalidMessage="Please enter a valid postcode"
                        theme={theme === "dark" ? "light" : null}
                      />
                    </div>
                    <Button
                      variant="primary"
                      theme={theme === "dark" ? "light" : null}
                      type="button"
                      isStretched
                      onClick={this.handleEnterPostcode}>Continue</Button>
                  </Modal>

                </main>
            </Layout>
        );
    }
}

export default PriceCalculator;
